




















































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Group } from "@/store/eventqueue/types";
import settingsApi from "@/services/api.settings.service";
import FileStore from "@/types/settings/filestores/FileStore";
import { VueBootstrapField } from "@/store/types";
import { BTable } from "bootstrap-vue";
import FileStoreEditModal, { EditorFileStore } from "./FileStoreEditModal.vue";
import FileStoreDeleteModal from "./FileStoreDeleteModal.vue";
import { Portal } from "@linusborg/vue-simple-portal";
import FileStoreType from "@/types/settings/filestores/FileStoreType";
import { S3FileStoreConfig } from "@/types/settings/filestores/S3FileStoreConfig";
import { stringMixin } from "@/mixins";
import { parse } from "qs";

const { isNullOrWhitespace } = stringMixin.methods;
const Areas = namespace("areas");

/**
 * Gets the path string to display to the user for a specified filestore.
 */
export function getPathForFileStore(fileStore: FileStore) {
	switch (fileStore.fileStoreTypeId) {
		case FileStoreType.Windows: {
			return fileStore.path;
		}
		case FileStoreType.S3: {
			try {
				const parsedConfig: S3FileStoreConfig = JSON.parse(fileStore.config);
				let path = "";

				if (!isNullOrWhitespace(parsedConfig.Region)) {
					path = `Region: ${parsedConfig.Region}`;
				} else {
					path = `Endpoint: ${parsedConfig.EndpointUrl}${
						parsedConfig.EndpointPort ? ":" + parsedConfig.EndpointPort : ""
					}`;
				}

				return `Bucket: ${parsedConfig.Bucket}, ${path}`;
			} catch (err) {
				return "Unknown";
			}
		}
	}
}

@Component({
	components: {
		"file-store-edit-modal": FileStoreEditModal,
		"file-store-delete-modal": FileStoreDeleteModal,
		portal: Portal
	}
})
export default class FilestoreSettings extends Vue {
	$refs: {
		table: BTable;
	};

	@Prop({ default: null, type: Object }) public selectedGroup: Group;

	@Areas.Action private fetchAreaDictionary: () => Promise<void>;
	@Areas.Getter private getAreaTitle: (groupId: number) => string;

	private readonly windowsFileStoreType = FileStoreType.Windows;
	private readonly s3FileStoreType = FileStoreType.S3;

	/**
	 * Fields for the BTable.
	 */
	private readonly fields: VueBootstrapField[] = [
		{ key: "fileStoreTypeId", label: "Type", sortable: true },
		{ key: "path", label: "Path", sortable: true },
		{ key: "groupId", label: "Area", sortable: false },
		{ key: "active", label: "Status", sortable: true },
		{ key: "actions", label: "Actions", sortable: false }
	];

	private fileStores: FileStore[] = [];
	private loadingFileStores: boolean = true;

	private editorFileStore: EditorFileStore = null;
	private deleteFileStore: FileStore = null;

	private async mounted() {
		await this.fetchAreaDictionary();
		await this.fetchFileStores(true);
	}

	/**
	 * Highlights the file store in the table for the specified group.
	 */
	@Watch("selectedGroup")
	private async highlightFileStoreForSelectedGroup() {
		var fileStoreForGroup = await settingsApi.getFileStoreForGroup(this.selectedGroup.groupID);
		var fileStoreIndex = this.fileStores.findIndex(
			fileStore => fileStore.fileStoreId == fileStoreForGroup.fileStoreId
		);

		this.$refs.table.clearSelected();
		this.$refs.table.selectRow(fileStoreIndex);
	}

	/**
	 * Fetches the list of available file stores from the data service.
	 */
	private async fetchFileStores(showLoader: boolean) {
		this.loadingFileStores = showLoader;
		this.fileStores = await settingsApi.getFileStores();
		this.loadingFileStores = false;

		await this.highlightFileStoreForSelectedGroup();
	}

	/**
	 * Handler for when the user clicks the add file store button. Creates a new one and passes it to the editor.
	 */
	private onCreateFileStoreClicked() {
		this.editorFileStore = {
			fileStoreId: 0,
			path: "",
			username: "",
			password: "",
			active: true,
			isNew: true,
			groupId: null,
			fileStoreTypeId: 1,
			config: null
		};
	}

	private getPathForFileStore = getPathForFileStore;
}
